import {brandConfigMap, getBrandConfig} from "@/brand";
import store from "@/store";
import {Brands} from "@/brand/brandConfig";

export function setBrandConfig() {
    const domain = window.origin;
    const urlParams = new URLSearchParams(window.location.search);
    const network = urlParams.get('nt');
    const domainBrandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');

    let brandConfig;

    // Keep explicit domain mappings, like Rugga Nation, from being overridden by generic network selection.
    if (domainBrandConfig.brand === Brands.WorldPlayRuggaNationSouthAfricaEnglish) {
        brandConfig = domainBrandConfig;
    } else if (network === 'MTN') {
        brandConfig = getBrandConfig(Brands.MTNWorldPlaySouthAfticaEnglish);
    } else if (network === 'Telkom') {
        brandConfig = getBrandConfig(Brands.TelkomWorldPlaySouthAfticaEnglish);
    } else {
        // Fall back to domain-based configuration if no network parameter
        brandConfig = domainBrandConfig;
    }

    store.commit('setBrandConfig', brandConfig);
    document.title = brandConfig.gameTitle || 'Rugby Zone';
    console.log(brandConfig);

    const brandStyles = require(`../brand/${brandConfig.brand}/styles/index.js`).styles;
    const brandStyleSheet = document.createElement('style');

    let brandStyleInnerHTML = '';

    brandStyles.backgrounds.forEach((background) => {
        brandStyleInnerHTML += ` .${background.className} { background-color: ${background.colour} }`;
    });

    brandStyles.text.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { color: ${textItem.colour} }`;
    });

    if (brandConfig.brand === 'wp-za-en' || brandConfig.brand === 'mtn-wp-za-en' || brandConfig.brand === 'telkom-wp-za-en' || brandConfig.brand === 'wp-rn-za-en') {
        if (brandStyles.contextualText && Array.isArray(brandStyles.contextualText)) {
            brandStyles.contextualText.forEach((contextItem) => {
                const parent = contextItem.parentClassName;
                const child = contextItem.className;
                const colour = contextItem.colour;
                const fontWeight = contextItem.fontWeight;
                const fontStyle = contextItem.fontStyle;
                const textDecoration = contextItem.textDecoration;
                let extra = '';
                if (fontWeight) extra += `; font-weight: ${fontWeight}`;
                if (fontStyle) extra += `; font-style: ${fontStyle}`;
                if (textDecoration) extra += `; text-decoration: ${textDecoration}`;
                brandStyleInnerHTML += ` .${parent}.${child}, .${parent} .${child} { color: ${colour}${extra} }`;
            });
        }
    }

    brandStyles.borders.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { border: 1.5px solid ${textItem.colour} }`;
    });

    if (brandStyles.appBackground) {
        brandStyleInnerHTML += ` .vue-container { background-image: none; background-color: ${brandStyles.appBackground} }`;
    }

    brandStyleSheet.innerHTML = brandStyleInnerHTML;
    document.body.appendChild(brandStyleSheet);
}
